// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__qLy6z","icon":"SortAdornment_icon__2GDAF","up":"SortAdornment_up__19Pej","down":"SortAdornment_down__3Upke","active":"SortAdornment_active__2-w6B"};